import React, { useImperativeHandle, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Editor as IEditor } from "tinymce";
import { UploadImageModal } from "./components/UploadImageModal";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ReactQuill, { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";

let editorRef: any = null;

interface IRichTextEditor {
  onChange: (content: string) => void;
  onInit: () => void;
}

export const RichTextEditor = React.forwardRef(({ onChange, onInit }: IRichTextEditor, ref) => {
  const [initValue, setInitValue] = useState("");
  useImperativeHandle(ref, () => ({
    setContent: (content: string) => {
      editorRef.setContent(content);
      setInitValue(content);
    },
  }));

  const [visibleUploadModal, setVisibleUploadModal] = useState(false);

  return (
    <>
      <div style={{ textAlign: "right", marginBottom: 12 }}>
        <Button icon={<UploadOutlined />} onClick={() => setVisibleUploadModal(true)} type="primary">
          Upload ảnh
        </Button>
      </div>

      <Editor
        apiKey="1s8l7u6g8q7e4hz0ljw15rbdh9g7l2pmh72hij5115qcpk2z"
        onInit={(evt, editor) => {
          editorRef = editor;
          onInit?.();
        }}
        onEditorChange={(val) => {
          onChange(val);
        }}
        initialValue={initValue}
        init={{
          entity_encoding: "numeric",
          height: 500,
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount emoticons",
          ],
          toolbar:
            "undo redo | formatselect | image emoticons | " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />

      <UploadImageModal
        onClose={() => setVisibleUploadModal(false)}
        onSubmitOk={(path) => {
          setVisibleUploadModal(false);
          editorRef.insertContent(`<img src="${path}"/>`);
        }}
        visible={visibleUploadModal}
      />
    </>
  );
});
